export var Websocket_ErrCode = function () {
  //__ENUM_IIFE__
  var Websocket_ErrCode;

  (function (Websocket_ErrCode) {
    Websocket_ErrCode[Websocket_ErrCode["Success"] = 0] = "Success";
  })(Websocket_ErrCode || (Websocket_ErrCode = {}));

  return Websocket_ErrCode;
}(); // @ignore: all

export var Websocket_Cmd = function () {
  //__ENUM_IIFE__
  var Websocket_Cmd;

  (function (Websocket_Cmd) {
    Websocket_Cmd[Websocket_Cmd["CMD_NIL"] = 0] = "CMD_NIL";
    Websocket_Cmd[Websocket_Cmd["CMD_PING"] = 1] = "CMD_PING";
    Websocket_Cmd[Websocket_Cmd["CMD_PONG"] = 2] = "CMD_PONG";
    Websocket_Cmd[Websocket_Cmd["CMD_ECHO"] = 3] = "CMD_ECHO";
    Websocket_Cmd[Websocket_Cmd["CMD_PUSH"] = 4] = "CMD_PUSH";
    Websocket_Cmd[Websocket_Cmd["CMD_FLAGS_OP"] = 5] = "CMD_FLAGS_OP";
    Websocket_Cmd[Websocket_Cmd["CMD_INIT"] = 100] = "CMD_INIT";
  })(Websocket_Cmd || (Websocket_Cmd = {}));

  return Websocket_Cmd;
}();
export var Websocket_ConnType = function () {
  //__ENUM_IIFE__
  var Websocket_ConnType;

  (function (Websocket_ConnType) {
    Websocket_ConnType[Websocket_ConnType["ConnTypeNil"] = 0] = "ConnTypeNil";
    Websocket_ConnType[Websocket_ConnType["ConnTypeRoom"] = 1] = "ConnTypeRoom";
    Websocket_ConnType[Websocket_ConnType["ConnTypeDevTool"] = 2] = "ConnTypeDevTool";
    Websocket_ConnType[Websocket_ConnType["ConnTypeQMsg"] = 3] = "ConnTypeQMsg";
  })(Websocket_ConnType || (Websocket_ConnType = {}));

  return Websocket_ConnType;
}();
export var Websocket_ConnFlag = function () {
  //__ENUM_IIFE__
  var Websocket_ConnFlag;

  (function (Websocket_ConnFlag) {
    Websocket_ConnFlag[Websocket_ConnFlag["ConnFlagNil"] = 0] = "ConnFlagNil";
    Websocket_ConnFlag[Websocket_ConnFlag["ConnFlagMute"] = 1] = "ConnFlagMute";
  })(Websocket_ConnFlag || (Websocket_ConnFlag = {}));

  return Websocket_ConnFlag;
}();
export var Websocket_ClientType = function () {
  //__ENUM_IIFE__
  var Websocket_ClientType;

  (function (Websocket_ClientType) {
    Websocket_ClientType[Websocket_ClientType["ClientTypeNil"] = 0] = "ClientTypeNil";
    Websocket_ClientType[Websocket_ClientType["ClientTypeMobile"] = 1] = "ClientTypeMobile";
    Websocket_ClientType[Websocket_ClientType["ClientTypePc"] = 2] = "ClientTypePc";
  })(Websocket_ClientType || (Websocket_ClientType = {}));

  return Websocket_ClientType;
}();
export var Websocket_FlagsOpMsg_OpType = function () {
  //__ENUM_IIFE__
  var Websocket_FlagsOpMsg_OpType;

  (function (Websocket_FlagsOpMsg_OpType) {
    Websocket_FlagsOpMsg_OpType[Websocket_FlagsOpMsg_OpType["OpTypeNil"] = 0] = "OpTypeNil";
    Websocket_FlagsOpMsg_OpType[Websocket_FlagsOpMsg_OpType["OpTypeSet"] = 1] = "OpTypeSet";
    Websocket_FlagsOpMsg_OpType[Websocket_FlagsOpMsg_OpType["OpTypeBitOr"] = 2] = "OpTypeBitOr";
    Websocket_FlagsOpMsg_OpType[Websocket_FlagsOpMsg_OpType["OpTypeBitClear"] = 3] = "OpTypeBitClear";
  })(Websocket_FlagsOpMsg_OpType || (Websocket_FlagsOpMsg_OpType = {}));

  return Websocket_FlagsOpMsg_OpType;
}();
export var Websocket_DevToolPushMessage_Type = function () {
  //__ENUM_IIFE__
  var Websocket_DevToolPushMessage_Type;

  (function (Websocket_DevToolPushMessage_Type) {
    Websocket_DevToolPushMessage_Type[Websocket_DevToolPushMessage_Type["TypeNil"] = 0] = "TypeNil";
    Websocket_DevToolPushMessage_Type[Websocket_DevToolPushMessage_Type["TypeTermDebug"] = 1] = "TypeTermDebug";
    Websocket_DevToolPushMessage_Type[Websocket_DevToolPushMessage_Type["TypeApiCall"] = 2] = "TypeApiCall";
  })(Websocket_DevToolPushMessage_Type || (Websocket_DevToolPushMessage_Type = {}));

  return Websocket_DevToolPushMessage_Type;
}();